import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { TreeMultiSelectComponent } from './tree-multi-select.component';
import { NzTreeModule } from 'ng-zorro-antd/tree';
import { NzInputModule } from 'ng-zorro-antd/input';

@NgModule({
    declarations: [TreeMultiSelectComponent],
    imports: [CommonModule, FormsModule, NzTreeModule, NzInputModule],
    exports: [TreeMultiSelectComponent],
})
export class TreeMultiSelectModule {}
